import { useQuery } from '@tanstack/react-query';

import useUser from 'hooks/useUser';
import fetchProjects from 'api/project/fetchProjects';
import API_END_POINT from 'constants/apiEndPoints';

const useProjects = () => {
  const user = useUser();
  const projects = useQuery({
    queryKey: [API_END_POINT.PROJECT.FETCH_PROJECTS, user.data?.userEmail],
    queryFn: () => fetchProjects({ userEmail: user.data!.userEmail }),
    enabled: !!user.data?.userEmail,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: 'always',
  });

  return {
    isLoading: user.isLoading || projects.isLoading,
    isError: user.isError || projects.isError,
    projects: projects.data?.projectList,
    refetch: projects.refetch,
  };
};

export default useProjects;
